module.exports = __webpack_public_path__ + "img/logo-wave.d0839793.svg";